export default __webpack_public_path__ + "static/Chiro Charge pt-93602ef4f248f3037db6c7e582dfc333.jpg";